export default __webpack_public_path__ + "static/media/refine.af9f0f2c.webp";